import React from 'react'

export default function CrmReports() {
  return (
    <div>
      CrmReports
    </div>
  )
}
